import { Api } from '@coderhouse/common'
import { PurchaseModal } from '@/models/modal'

const { VUE_APP_CH_API_BFF } = process.env

async function getModalInfo(id: string, country: string): Promise<PurchaseModal> {
  const modalInfo = await Api.get(`${VUE_APP_CH_API_BFF}/v1/home/available-suggested-courses?country=${country}&levelId=${id}`)
  return new PurchaseModal(modalInfo)
}

export { getModalInfo }
